import React, { useState } from 'react';
import AnimateHeight from 'react-animate-height';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import Widgets from '@interness/web-core/src/components/modules/Widgets';
import * as S from './styles';
import ConditionalWrapper from '@interness/web-core/src/components/structure/ConditionalWrapper/ConditionalWrapper';

// TODO make configurable via api
import { jsx as ___EmotionJSX } from "@emotion/react";
const defaultWidgets = [{
  sort: 1,
  widget_name: 'address',
  props: {},
  translations: [{
    language: 'de',
    header: 'Adresse'
  }]
}, {
  sort: 2,
  widget_name: 'contact',
  props: {},
  translations: [{
    language: 'de',
    header: 'Kontakt'
  }]
}, {
  sort: 3,
  widget_name: 'openingHours',
  props: {},
  translations: [{
    language: 'de',
    header: 'Öffnungszeiten'
  }]
}];
const Chevron = _ref => {
  let {
    direction
  } = _ref;
  if (direction === 'up') {
    return ___EmotionJSX(FaChevronUp, null);
  } else {
    return ___EmotionJSX(FaChevronDown, null);
  }
};
const Boxgroup = _ref2 => {
  let {
    floating,
    barColor
  } = _ref2;
  const {
    0: open,
    1: setOpen
  } = useState(floating);
  const toggle = () => {
    setOpen(!open);
  };
  return ___EmotionJSX(S.Group, {
    floating: floating
  }, !floating && ___EmotionJSX(S.ToogleBar, {
    bg: barColor
  }, ___EmotionJSX("button", {
    onClick: toggle
  }, "Kontakt ", ___EmotionJSX(Chevron, {
    direction: open ? 'up' : 'down'
  }))), ___EmotionJSX(S.Box, {
    floating: floating
  }, ___EmotionJSX(ConditionalWrapper, {
    condition: !floating,
    wrapper: children => ___EmotionJSX(AnimateHeight, {
      height: open ? 'auto' : 0
    }, children)
  }, ___EmotionJSX("div", {
    className: "int-widget-box"
  }, ___EmotionJSX(Widgets, {
    widgets: defaultWidgets,
    lang: 'de'
  })))));
};
Boxgroup.defaultProps = {
  floating: true
};
export default Boxgroup;